import { getApiClient } from "@src/api";
import type { WhiteboardDocumentId } from "@src/components/collaboration/document-id";
import { graphql } from "@src/gql";
import { queryOptions } from "@tanstack/react-query";
import { WhiteboardWithUsersSchema } from "../schema";
import { whiteboardQueryKeys } from "./query-keys";

export const activeWhiteboardQuery = graphql(/* GraphQL */ `
	query activeWhiteboardWithSharePanel($whiteboardId: String!, $shareKey: String) {
		whiteboards {
			list(shareKey: $shareKey, where: { id: { eq: $whiteboardId } }) {
				...WhiteboardDetailsFragment
				collaboration {
					...DetailedCollboarationFragment
				}
				publication {
					...PublicationFragment
				}
				trail {
					...TrailFragment
				}
			}
		}
	}
`);

export const fetchActiveWhiteboardQueryFn = async (
	whiteboardId: WhiteboardDocumentId,
	shareKey: string | null,
) => {
	const client = getApiClient();

	const response = await client.query({
		query: activeWhiteboardQuery,
		variables: {
			whiteboardId: whiteboardId.toIdString(),
			shareKey,
		},
	});

	const whiteboard = response.data?.whiteboards.list?.[0];

	if (!whiteboard) {
		return null;
	}

	return WhiteboardWithUsersSchema.parse(whiteboard);
};

export const fetchActiveWhiteboardQueryOptions = (
	whiteboardId: WhiteboardDocumentId,
	shareKey: string | null,
) => {
	return queryOptions({
		queryKey: whiteboardQueryKeys.ofId(whiteboardId.toIdString()),
		queryFn: () => fetchActiveWhiteboardQueryFn(whiteboardId, shareKey),
	});
};
